import React from 'react';
import cn from 'classnames';
import { useQueryClient } from 'react-query';
import CommentsCard from '../RequestCommentsCard/RequestCommentsCard';
import TenantAndBillCard from '../RequestTenantAndBillCard/RequestTenantAndBillCard';
import AttachmentsCard from '../RequestAttachmentsCard/RequestAttachmentsCard';
import ContractorCard from '../RequestContractorCard/RequestContractorCard';
import useWarrantyDocs from '../../../queries/useWarrantyDocs';
import styles from './CardsContainer.module.scss';

const notWarrantyId = 0;

const CardList = ({ withWarranty = false, request, canChange = true }) => {
  return (
    <>
      <TenantAndBillCard
        style={{ gridColumn: !withWarranty ? '1/5' : '1/4' }}
        request={request}
        canChange={canChange}
      />
      <CommentsCard
        style={{ gridColumn: !withWarranty ? '5/9' : '4/7' }}
        request={request}
        canChange={canChange}
      />
      <AttachmentsCard
        cardStyle={{ gridColumn: !withWarranty ? '9/-1' : '7/10' }}
        request={request}
        canChange={canChange}
      />
      {withWarranty ? (
        <ContractorCard
          style={{ gridColumn: '10/-1' }}
          request={request}
          canChange={canChange}
        />
      ) : null}
    </>
  );
};

const NotWarrantyContainer = ({ request, canChange }) => {
  const queryClient = useQueryClient();
  const warrantyDocs =
    queryClient.getQueryData([`warrantyDocs`, request.id]) || {};
  const hasWarrantyDocs = Boolean(warrantyDocs?.length);

  return (
    <CardList
      withWarranty={hasWarrantyDocs}
      request={request}
      canChange={canChange}
    />
  );
};

const CardsContainer = ({
  request,
  rootClassName,
  canChange = true,
  ...props
}) => {
  useWarrantyDocs(request.id);

  return (
    <div
      {...props}
      className={cn(styles.root, rootClassName)}
    >
      {request.garantyId === notWarrantyId ? (
        <NotWarrantyContainer
          request={request}
          canChange={canChange}
        />
      ) : (
        <CardList
          withWarranty
          request={request}
          canChange={canChange}
        />
      )}
    </div>
  );
};

export default CardsContainer;
